/**
 * Saves the parameters of the last render into renderingTools, used later to decide if data can be reused.
 *
 * @param {object} enabledElement Cornerstone EnabledElement
 * @returns {object} enabledElement.renderingTools
 * @memberof rendering
 */

/**
 * Save last rendered status of enabled element
 *
 * @param {object} enabledElement - Enabled element
 * @returns {*} status
 */
function saveLastRendered(enabledElement) {
  const imageId = enabledElement.image.imageId;
  const viewport = enabledElement.viewport;
  const isColor = enabledElement.image.color;

  enabledElement.renderingTools.lastRenderedImageId = imageId;
  enabledElement.renderingTools.lastRenderedIsColor = isColor;
  enabledElement.renderingTools.lastRenderedViewport = {
    windowCenter: viewport.voi.windowCenter,
    windowWidth: viewport.voi.windowWidth,
    invert: viewport.invert,
    rotation: viewport.rotation,
    hflip: viewport.hflip,
    vflip: viewport.vflip,
    modalityLUT: viewport.modalityLUT,
    voiLUT: viewport.voiLUT,
    colormap: viewport.colormap,
  };

  return enabledElement.renderingTools;
}

export default saveLastRendered;
